import { ERROR_CALL_TO_ACTION_MAP, ERROR_MAP } from '../constants';

function ImportDiscoverAssetError() {
  this.name = 'Import Discover Asset Error';
  this.message = ERROR_MAP.IMPORT_DISCOVER_ASSET;
  this.callToAction = ERROR_CALL_TO_ACTION_MAP.CONTACT_SUPPORT;

  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
  this.stack = new Error().stack;
}

ImportDiscoverAssetError.prototype = Object.create(Error.prototype);
ImportDiscoverAssetError.prototype.constructor = ImportDiscoverAssetError;

export default ImportDiscoverAssetError;
